import {
    UPDATE_VEHICLES_URL,
    CREATE_VEHICLE_URL,
    DELETE_VEHICLE_URL,
    GET_SEAT_GROUPS_URL,
    GET_SEAT_TYPES_URL,
    CREATE_AGENT_BUS_URL,
    UPDATE_AGENT_BUS_URL, GET_BUS_BY_ID_URL, GET_COACH_TYPE_URL, VALIDATE_SEAT_URL,
    DELETE_AGENT_BUS_URL, GET_BUS_TEMPLATE_URL, GET_SEAT_LAYOUT_BY_TEMPLATE_ID_URL
  } from "../utils/api-url";
import { postCall, getCall } from "../utils/network.util";
import { message } from "antd";
import { SUCCESS_STATUS } from "../utils/constant";

export const createVechicle = ({ bus_id,vechicle_no},onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(CREATE_VEHICLE_URL,{
        vechicleInfo:{
            bus_id:bus_id,
            vechicle_no:vechicle_no
        },
        operator_code:global.operator_code
    }).then(response=>{
        if(response.status==SUCCESS_STATUS && response.payload.Status==SUCCESS_STATUS){
            onSuccess();
        }else{
            onFailure();
            if(response.status==SUCCESS_STATUS){
                message.error(response.payload.Message);
            }else{
                message.error("Failed to create vechicle");
            }
        }
    });
}

export const deleteVechicle = (vechicleId,onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(DELETE_VEHICLE_URL,{
        vechicleId:vechicleId,
        operator_code:global.operator_code
    }).then(response=>{
        if(response.status==SUCCESS_STATUS && response.payload.Status==SUCCESS_STATUS){
            onSuccess();
        }else{
            onFailure();
            if(response.status==SUCCESS_STATUS){
                message.error(response.payload.Message);
            }else{
                message.error("Failed to delete vechicle");
            }
        }
    });
}

export const updateVechiclesForSchedule=(scheduleId,vechicleId,phoneNo,onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(UPDATE_VEHICLES_URL,{
        schedule:{
            id:scheduleId,
            phone_no:phoneNo,
            vechicle_id:vechicleId
        },
        operator_code:global.operator_code
    }).then(response=>{
        if(response.status==SUCCESS_STATUS && response.payload.Status==SUCCESS_STATUS){
            onSuccess();
        }else{
            onFailure();
            if(response.status==SUCCESS_STATUS){
                message.error(response.payload.Message);
            }else{
                message.error("Failed to update vechicle");
            }
        }
    });
}


export const getSeatGroupsAction = (onSuccess=()=>{},onFailure=()=>{})=>{
    getCall(GET_SEAT_GROUPS_URL).
    then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess(response.payload.Payload);
        }else{
            onFailure();
        }
    });
}

export const getSeatTypeAction = (onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(GET_SEAT_TYPES_URL,{
        operator_code:global.operator_code
    }).then(response=>{
        if(response.status==SUCCESS_STATUS && response.payload.Status==SUCCESS_STATUS){
            onSuccess(response.payload.Payload);
        }
    })
}

export const createAgentBusAction = (busLayoutData, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(CREATE_AGENT_BUS_URL, {busLayoutData}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess();
        } else {
            onFailure();
        }
    });
}

export const updateAgentBusAction = (busLayoutData, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(UPDATE_AGENT_BUS_URL, {busLayoutData}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess();
        } else {
            onFailure();
        }
    });
}

export const deleteAgentBusAction = (busId, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(DELETE_AGENT_BUS_URL, {
        busId: busId,
        operator_code: global.operator_code
    }).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess();
        } else {
            onFailure();
            if (response.status === SUCCESS_STATUS) {
                message.error(response.payload.Message);
            } else {
                message.error("Failed to delete bus");
            }
        }
    });
}

export const getBusByIdAction = (busId,onSuccess=()=>{},onFailure=()=>{})=>{
    let url = GET_BUS_BY_ID_URL + "?busId=" + busId;
    getCall(url).
    then(response => {
        if (response.status === SUCCESS_STATUS) {
            onSuccess(response.payload.bus);
        }else{
            onFailure();
        }
    });
}

export const getCoachTypeAction = (onSuccess=()=>{}, onFailure=()=>{})=> {
    postCall(GET_COACH_TYPE_URL, {}).then(response => {
        if(response.status == SUCCESS_STATUS) {
            onSuccess(response.payload.Payload);
        }else {
            onFailure();
        }
    })
}

export const getBusTemplatesAction = (onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(GET_BUS_TEMPLATE_URL, {}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess(response.payload.Payload);
        } else {
            onFailure();
        }
    });
}

export const fetchSeatLayoutByTemplateIdAction = (templateId, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(GET_SEAT_LAYOUT_BY_TEMPLATE_ID_URL, { templateId }).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess(response.payload.Payload.seatLayout);
        } else {
            onFailure();
        }
    });
}

export const validateSeatLayoutAction = (busId, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(VALIDATE_SEAT_URL, {busId}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            message.success(response.payload.Message);
            onSuccess();
        } else {
            message.error(response.payload.Message);
            onFailure();
        }
    });
}